import ErrorMessage from './ErrorMessage';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import useT from '@hooks/useT';

function ServerUnavailableError() {
  const { t } = useT('errors');
  return (
    <ErrorMessage
      title={t('components.serverUnavailable.title')}
      message={t('components.serverUnavailable.message')}
      icon={<CloudOffIcon />}
      severity="error"
    />
  );
}

export default ServerUnavailableError;
